import React, { Component } from 'react';

export default class KpisSection extends Component {

  render() {
    return (
      <div className='Stats'>
        <div className='squareStats'>
          <p className='squareStats-number'>128</p>
          <p className='squareStats-title'>Inventarios totales</p>
        </div>
        <div className='squareStats'>
          <p className='squareStats-number'>5</p>
          <p className='squareStats-title'>Inventarios planificados</p>
        </div>
        <div className='squareStats'>
          <p className='squareStats-number'>10</p>
          <p className='squareStats-title'>Prom. inventarios x dia</p>
        </div>
        <div className='squareStats'>
          <p className='squareStats-number'>+5%</p>
          <p className='squareStats-title'>Comparativa mes previo</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FichaLogistica/Inventario/KpisSection.js